import React from "react";

function Header() {
  return (
    <>
      <header
        className="w-full bg-fixed bg-no-repeat bg-contain h-52"
        style={{ backgroundImage: "url(./Images/Building_cleanup.png)" }}
      >
        <span className="flex items-end w-full h-full p-5 text-4xl font-extrabold bg-black text-color-base bg-opacity-30 ">
          RFC
        </span>
      </header>
    </>
  );
}

export default Header;
